import ApiError, { ApiNotReadyError } from '@/features/api/error'
import { AxiosError, AxiosInstance } from 'axios'

export class ErrorTransformInterceptor {
    private axiosInstance: AxiosInstance

    constructor(axiosInstance: AxiosInstance) {
        this.axiosInstance = axiosInstance

        this.attachInterceptor()
    }

    private attachInterceptor = (): void => {
        this.axiosInstance.interceptors.response.use((response) => response, this.onResponseError)
    }

    private onResponseError = async (error: AxiosError | ApiNotReadyError): Promise<never> => {
        if (error instanceof ApiNotReadyError) {
            return Promise.reject(error)
        }

        return Promise.reject(
            new ApiError(
                error,
                error.response?.status,
                error.config?.extras?.errorIdentifier?.(error),
                error.config?.extras?.missingNetworkConnection
            )
        )
    }
}
